import React, {Component} from 'react';
import {Row, Col, Input, Spin, Radio} from "antd";
import config from "../../config";
import Card from "../../components/Card";
import {api, app} from "../../app";

const RadioGroup = Radio.Group
const RadioButton = Radio.Button

class IntroduceList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data_load_id: undefined,
            courseList: [],
            title: '',
            url: '',
            search_name: '',
        }
    }

    async componentDidMount() {
        this._isMounted = true;
        await this.handleDataList()
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 数据
     * @returns {Promise<void>}
     */
    handleDataList = async () => {
        await this.setData({ loading: true })
        let { search_name } = this.state, params = {
            search_value: search_name,
            type: 1
        }
        let { flag, data, msg } = await app.post(api.SkillTrainCourseDescription, params), courseInfo = {}
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (data.length > 0) {
            courseInfo.name = data[0].inform_name
            let id = {
                target:{value:data[0].id}
            }
            this.handleSelectManual(id)
        }
        await this.setData({ loading: false, courseList: data, courseInfo })
    }

    /**
     * 选择通知
     **/
    handleSelectManual = async (e) => {
        await this.setData({ detail_loading:true, data_load_id: e.target.value })
        let {courseList} = this.state
        courseList.map(async (value) => {
            if (value.id == e.target.value) {
                await this.setData({title: value.inform_name, url: value.url})
            }
        })
        await this.setData({ detail_loading:false })
    }

    /**
     * 手册搜索
     **/
    handleSearch = async (search_name) => {
        console.log(search_name)
        await this.setData({search_name})
        await this.handleDataList()
    }

    render() {
        let { data_load_id, courseList, loading, title, url, detail_loading } = this.state,
            card_style = {
                padding: 25,
                height: 'calc(100vh - 228px)',
                borderLeft: '1px solid #eee',
                borderBottom: '1px solid #eee',
                borderRight: '1px solid #eee',
            }
        return (
            <div className="course-list">
                <Row style={{ height: '100%' }}>
                    <Col span={6} style={{ height: '100%' }}>
                        <Card width="100%" height="100%" title="介绍列表" style={card_style}>
                            <div style={{ height: '100%' }}>
                                <Input.Search
                                    placeholder="输入关键词搜索"
                                    onSearch={this.handleSearch}
                                    className="search"
                                />
                                {
                                    loading ?
                                        (<Row className="data-loading" type="flex" align="middle"
                                              justify="center"><Spin/></Row>) :
                                        <RadioGroup onChange={this.handleSelectManual} className="course-list-r"
                                                    value={data_load_id}>
                                            {
                                                courseList.length > 0 ?
                                                    courseList.map((course, index) => {
                                                        return (
                                                            <RadioButton key={index + 1} className='no-select'
                                                                         value={course.id}>
                                                                <div title={course.inform_name}>{course.inform_name}</div>
                                                            </RadioButton>
                                                        )
                                                    }) : (
                                                        <p style={{ textAlign: "center", padding: "20px 0" }}>无对应手册</p>)
                                            }
                                        </RadioGroup>
                                }
                            </div>
                        </Card>
                    </Col>
                    <Col span={17} offset={1}>
                        <Card width="100%" height="100%" title={title || '介绍'} style={card_style}>
                            {
                                detail_loading ?
                                    (<Row className="data-loading" type="flex" align="middle"
                                          justify="center"><Spin size="large"/></Row>) :
                                    <div className="nt-imgs">
                                        {url? <div className="nti-img"><img src={config.imgUrl + url} alt=""/></div>:null}
                                    </div>
                            }
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}
export default IntroduceList;



// WEBPACK FOOTER //
// ./src/routes/skillTrain/IntroduceList.jsx